import React from "react";
import { Menu, MenuItem } from "@mui/material";
import PropTypes from "prop-types";

function MenuComponent({
  menuAnchorEl,
  openAnchor,
  userId,
  userp,
  handleCloseMenu,
  isLocked,
  isActive,
  handleLockUser,
  handleActivateUser,
  handleDeleteUser,
  handleResetPasswordUser,
  openEmailModel,
  handleEditUser,
}) {
  const lockUser = (uId, val) => {
    handleLockUser(uId, val);
  };
  const activateUser = (uId, val) => {
    handleActivateUser(uId, val);
  };
  const deleteUser = (uId) => {
    handleDeleteUser(uId);
  };
  const resetUserPassword = (uId) => {
    handleResetPasswordUser(uId);
  };
  const handleEmailModal = () => {
    openEmailModel();
  };
  return (
    <div>
      <Menu
        id={userId}
        open={openAnchor}
        anchorEl={menuAnchorEl}
        onClose={handleCloseMenu}
      >
        <MenuItem
          id={userId}
          onClick={() => {
            handleEditUser(userp);
            handleCloseMenu();
          }}
        >
          Edit User
        </MenuItem>
        <MenuItem
          id={userId}
          onClick={() => resetUserPassword(userp.user.email)}
        >
          Reset Password
        </MenuItem>
        {isLocked === false && (
          <MenuItem id={userId} value={1} onClick={() => lockUser(userp.id, 1)}>
            Lock User
          </MenuItem>
        )}
        {isLocked === true && (
          <MenuItem id={userId} value={0} onClick={() => lockUser(userp.id, 0)}>
            Unlock User
          </MenuItem>
        )}
        <MenuItem
          id={userId}
          value={0}
          onClick={() => activateUser(userId, !isActive)}
        >
          {isActive ? "Deactivate user" : "Activate user"}
        </MenuItem>
        <MenuItem id={userId} onClick={() => handleEmailModal(userId)}>
          Email User
        </MenuItem>
        <MenuItem id={userId} onClick={() => deleteUser(userId)}>
          Delete User
        </MenuItem>
      </Menu>
    </div>
  );
}

MenuComponent.propTypes = {
  // eslint-disable-next-line
  userp: PropTypes.object,
  menuAnchorEl: PropTypes.func.isRequired,
  openAnchor: PropTypes.bool.isRequired,
  userId: PropTypes.number.isRequired,
  handleCloseMenu: PropTypes.func.isRequired,
  isLocked: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  handleLockUser: PropTypes.func.isRequired,
  handleActivateUser: PropTypes.func.isRequired,
  handleDeleteUser: PropTypes.func.isRequired,
  handleResetPasswordUser: PropTypes.func.isRequired,
  openEmailModel: PropTypes.func.isRequired,
  handleEditUser: PropTypes.func.isRequired,
};

export default MenuComponent;
